import React from "react";
import Chip from "@mui/material/Chip";
import {
  ProposalStatus,
  PROPOSAL_STATUS_LABELS,
  PROPOSAL_STATUS_COLOR,
} from "../../model/Proposal";
import type { SxProps } from "@mui/material";

interface ProposalStatusChipProps {
  status?: ProposalStatus | null;
  size?: "small" | "medium";
}

// Exact hex overrides matching WCAG 2.2 AA spec.
// #B91C1C (red-700, 5.08:1 on white) for declined/cancelled states.
// #166534 (green-800, ~5.1:1 on white) for accepted — one step darker than
// #15803D (green-700, 4.54:1) to provide margin above the 4.5:1 AA threshold.
const STATUS_SX: Partial<Record<ProposalStatus, SxProps>> = {
  DECLINED: { bgcolor: "#B91C1C", color: "#fff" },
  CANCELLED: { bgcolor: "#B91C1C", color: "#fff" },
  ACCEPTED: { bgcolor: "#166534", color: "#fff" },
};

const ProposalStatusChip: React.FC<ProposalStatusChipProps> = ({
  status,
  size = "small",
}) => {
  if (!status) return null;
  return (
    <Chip
      label={PROPOSAL_STATUS_LABELS[status] ?? status}
      color={PROPOSAL_STATUS_COLOR[status] ?? "default"}
      size={size}
      sx={{ fontWeight: 600, letterSpacing: "0.02em", ...STATUS_SX[status] }}
    />
  );
};

export default ProposalStatusChip;
